// Listen for when the document is ready
document.addEventListener('DOMContentLoaded', function () {
    // Function to check if a node or it's child nodes have non-empty text content
    function hasTextContent(node) {
        // Check if nodevalue is not empty
        if (node.nodeValue && node.nodeValue.trim() !== '') {
            return true;
        }

        // Loop through childNodes to check if they have non-empty content
        for (var iNode = 0; iNode < node.childNodes.length; iNode++) {
            if (hasTextContent(node.childNodes[iNode])) {
                return true;
            }
        }
        // If none of the children have non-empty content return false   
        return false;
    }

    // Select all h1 - h6 heading tags
    var headings = document.querySelectorAll('h1, h2, h3, h4, h5, h6');

    // Loop through all the headings and remove if the heading has no text or whitespace only
    for (var iHeading = 0; iHeading < headings.length; iHeading++) {
        if (!hasTextContent(headings[iHeading]) && !headings[iHeading].querySelector('img')) {
            headings[iHeading].parentNode.removeChild(headings[iHeading]);
        }
    }

    // Define the hasTextContent function
    function hasTextContent(element) {
        return element.textContent.replace(/\s/g, '').length > 0;
    }

    // Main blog div select
    var mainBlogDiv = document.querySelector(".main-blog");
    // Check if blog div exist
    if (mainBlogDiv) {
        // Get all the blog headings
        var blogHeading = document.querySelectorAll('.card__heading');
        // Check if blog headings exist
        if (blogHeading.length) {
            // Loop through blog headings and replace h3 tags with h2 tags
            for (var iBlogHeading = 0; iBlogHeading < blogHeading.length; iBlogHeading++) {
                var blogHeadingAdd = blogHeading[iBlogHeading].outerHTML.replace(/^<h3/, '<h2').replace(/<\/h3>$/, '</h2>');
                blogHeading[iBlogHeading].outerHTML = blogHeadingAdd;
            }
        }
    }

    // Check existance of h1 on the webpage
    var h1Exists = document.getElementsByTagName('h1').length > 0;

    // Search for first h2 in main content and replace it with h1, if h1 does not exists
    if (!h1Exists) {
        var h2 = document.querySelector('#MainContent h2');
        // if h2 exists, then replace the h2 tag with h1
        if (h2) {
            var h2Add = h2.outerHTML.replace(/^<h2/, '<h1').replace(/<\/h2>$/, '</h1>');
            h2.outerHTML = h2Add;
        }
    }

    // Fetch all buttons and anchor elements with class 'button' from the page
    var primaryButtons = Array.from(document.querySelectorAll('#MainContent button'));
    var anchorButtons = Array.from(document.querySelectorAll('#MainContent a.button'));

    // Create style element and append it to body
    var styleElement = document.createElement("style");
    document.body.appendChild(styleElement);

    // Handle button and anchorButton arrays separately
    [primaryButtons, anchorButtons].forEach(function (buttonGroup) {
        // Skip if the buttonGroup is empty
        if (!buttonGroup.length) return;

        var tagName = buttonGroup[0].tagName.toLowerCase();
        var selector = (tagName === 'a') ? tagName + '.button' : tagName;

        // Loop through each button in the group
        for (var iButton = 0, len = buttonGroup.length; iButton < len; iButton++) {
            // Fetch the computed style of the button
            var style = window.getComputedStyle(buttonGroup[iButton]);

            // Get background color value
            var bgColor = style.getPropertyValue('background-color').trim();

            // Check if background color is black
            if (bgColor === 'rgb(0, 0, 0)' || bgColor === 'rgba(0, 0, 0, 1)') {
                // If the background is black, insert a new rule to make the text color white
                var rule = `#MainContent ${selector}:nth-child(${iButton + 1}) { color: #ffffff !important; }`;
                styleElement.textContent += rule + '\n';
            }
        }
    });

    // Select and process every aside element
    let asides = document.querySelectorAll('aside[aria-labelledby]');
    asides.forEach(aside => {
        // If there are no elements referenced by aria-labelledby, remove the attribute
        let ariaLabelledBy = aside.getAttribute('aria-labelledby');
        let referencedElements = document.querySelectorAll('#' + ariaLabelledBy);

        if (referencedElements.length === 0) {
            aside.removeAttribute('aria-labelledby');
        }
    });

    // Fetch anchor tags with title attribute and remove it if text content equals title
    var anchors = document.querySelectorAll('a[title]');
    anchors.forEach(function (anchor) {
        var title = anchor.getAttribute('title');
        var text = anchor.textContent || anchor.innerText;
        if (title === text) {
            anchor.removeAttribute('title');
        }
    });

    // Check each image for the presence of an alt attribute and add it if missing
    const images = document.querySelectorAll('img');
    images.forEach(image => {
        if (!image.hasAttribute('alt')) {
            image.setAttribute('alt', '');
        }
    });

    // Perform styling update on span tags
    let spans = document.querySelectorAll('span[style="text-decoration: underline;"], span[style="text-decoration:underline"]');
    spans.forEach(span => {
        if (span.querySelectorAll('a').length === 0) {
            span.removeAttribute('style');
        }

        // Also inspect and modify nested span elements
        let nestedSpans = span.querySelectorAll('span');
        nestedSpans.forEach(nestedSpan => {
            if (nestedSpan.querySelectorAll('a').length === 0) {
                nestedSpan.removeAttribute('style');
            }
        })
    })

    // Perform updates on thumbnail buttons
    var thumbnailButtons = document.querySelectorAll('.product .thumbnail');

    for (var iButton = 0; iButton < thumbnailButtons.length; iButton++) {
        var img = thumbnailButtons[iButton].querySelector('img');
        // If images exists, clear it's alt attribute
        if (img) {
            img.alt = '';
        }

        // Remove aria-describedby attribute from the button
        thumbnailButtons[iButton].removeAttribute('aria-describedby');
    }

    //Fetch product media images and process their alt text
    const productMediaImages = document.querySelectorAll('.product-media-modal__content img');
    function processImages(images) {
        images.forEach(img => {
            if (img.parentElement.tagName !== 'BUTTON') {
                img.alt = "";
            }
        });
    }
    if (productMediaImages.length > 0) {
        processImages(productMediaImages);
    }

    // Options for the observer (which mutations to observe)
    const config = { attributes: false, childList: true, subtree: true };
    // Function to observe a specific element
    function observeElement(element, observer) {
        const cardMediaImages = element.querySelectorAll('.card__media .media img');
        processImages(cardMediaImages);
        observer.observe(element, config);
    }

    // Callback function to execute when mutations are observed
    const bodyObserverCallback = function (mutationsList, observer) {
        for (let mutation of mutationsList) {
            if (mutation.type === 'childList') {
                const productRecommendations = document.querySelector('.product-recommendations');
                const productGridContainer = document.querySelector('.product-grid-container');
                if (productRecommendations) {
                    const cardObserver = new MutationObserver(() => observeElement(productRecommendations, cardObserver));
                    observeElement(productRecommendations, cardObserver);
                }

                if (productGridContainer) {
                    const gridObserver = new MutationObserver(() => observeElement(productGridContainer, gridObserver));
                    observeElement(productGridContainer, gridObserver);
                }
            }
        }
    };

    // Start observing with the observer connected to the callback
    // NOTE: If any modifications were made which would need to be observed, ensure above observer is properly set to observe them
    const bodyObserver = new MutationObserver(bodyObserverCallback);
    bodyObserver.observe(document.body, config);

    // Add an user friendly span to PDF links
    function addSpanToPdfLinks() {
        const anchorElements = document.querySelectorAll('a[href]');
        const regex = new RegExp(/\.pdf/i);
        for (const anchorElement of anchorElements) {
            if (regex.test(anchorElement.href)) {
                const linkText = anchorElement.textContent;
                const spanElement = document.createElement('span');
                spanElement.textContent = '(link opens PDF document)';
                spanElement.classList.add('visually-hidden');

                // Append span element to the PDF link
                anchorElement.appendChild(spanElement);
            }
        }
    }

    // Call above defined function
    addSpanToPdfLinks();
});